:host {
  .collapse {
    border-bottom: 1px solid #2d3137;
  }

  ul {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: var(--sy-spacer-5, 24px);
    list-style: none;
  }

  .link {
    color: var(--sy-primary-contrast, #fff);
    text-decoration: none;
    display: block;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .link:hover,
  &:focus {
    color: hsl(0deg 0% 100% / 75%);
  }

  @keyframes open {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(45deg);
    }
  }

  @keyframes close {
    from {
      transform: rotate(45deg);
    }

    to {
      transform: rotate(0deg);
    }
  }

  .footer-collapse {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    --sy-icon-color: white;

    sy-icon {
      animation-duration: 0.2s;
      animation-timing-function: ease-in-out;

      &.open {
        animation-name: open;
        transform: rotate(45deg);
      }

      &.close {
        animation-name: close;
        transform: rotate(0deg);
      }
    }

    &:hover {
      cursor: pointer;

      --sy-icon-color: hsl(0deg 0% 100% / 75%);
    }
  }

  sy-collapse ul {
    margin-top: 16px;
    margin-bottom: 8px;
    margin-left: 16px;

    li {
      border: none;
      padding: 0;
      font-size: 12px;
    }

    .link {
      color: hsl(0deg 0% 100% / 75%);
    }

    &:focus,
    .link:hover {
      color: #fff;
    }
  }
}
